/**
 * Publish the rendering view's snapshot for the docked agent (app-shell ADR-014).
 *
 * `snapshot` MUST be memoized by the caller — an object rebuilt every render
 * would re-publish every render.
 */

import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { shogunViewSnapshotAtom, type ShogunViewSnapshot } from '../../stores/shogun/atoms';

export function usePublishViewSnapshot(snapshot: ShogunViewSnapshot | null): void {
  const publish = useSetAtom(shogunViewSnapshotAtom);

  useEffect(() => {
    publish(snapshot);
  }, [snapshot, publish]);

  useEffect(() => () => publish(null), [publish]);
}
